import { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarHomePage, RegisterUser, Login, Loading, FooterHomePage } from '../components';
import { ContainerImg, TitleHowItsWork } from './style';
import ImgPartOne_ from '../../../assets/img/Part01.png';
import HowItWorks from '../../../assets/img/HowItWorks.png';
import { OPTION_MENU } from '../../../constants/menu';
import SectionOne from '../components/sectionOne';
import SectionRegister from '../components/SectionRegister';
import { getCurrentUser } from '../../../service/CognitoAuthService';
import * as UserActions from '../../../core/users/action';
import * as HomeActions from '../../../core/home/action';
import * as VenueActions from '../../../core/venues/action';
import AboutSection from '../components/SectionAbout';
import { APP_ROUTES } from '../../../constants/app-routes';

export default function HomePageMain() {
  const dispatch = useDispatch();
  const { loginOpen, registerOpen, registerUserRole } = useSelector((store) => store.home);
  const [isLoading, setLoading] = useState(false);
  const [goAbout, setGoAbout] = useState(false);
  const navigate = useNavigate();

  const onSelectMenu = (value) => {
    // eslint-disable-next-line no-console
    console.log(value);
    switch (value) {
      case OPTION_MENU.LOGIN:
        dispatch(HomeActions.openLoginModal());
        return;
      case OPTION_MENU.JOIN_AS_VENUE:
        dispatch(HomeActions.openVenueRegisterModal());
        break;
      case OPTION_MENU.JOIN_AS_VENDOR:
        dispatch(HomeActions.openVendorRegisterModal());
        break;
      case OPTION_MENU.ABOUT_US:
        setGoAbout(true);
        break;
      case OPTION_MENU.HOME:
        setGoAbout(false);
        break;
      default:
        break;
    }
  };

  const openJoinVenue = () => {
    dispatch(HomeActions.openVenueRegisterModal());
  };

  const openJoinVendor = () => {
    dispatch(HomeActions.openVendorRegisterModal());
  };

  const onSuccess = (authResponse) => {
    try {
      console.log({ authResponse });
      const cognitoId = authResponse?.username;
      dispatch(UserActions.getUserByCognitoId(cognitoId, navigate));
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };
  const onSuccessRegister = () => {
    setLoading(false);
    dispatch(HomeActions.closeRegisterModal());
  };

  const { user } = useSelector((store) => store.users);

  useEffect(() => {
    try {
      if (!user) {
        const cognitoData = getCurrentUser();
        if (cognitoData) dispatch(UserActions.getUserByCognitoId(cognitoData.username, navigate));
      }
      navigate(APP_ROUTES.DASHBOARD);
    } catch (err) {
      dispatch(UserActions.resetUserState());
    }
  }, [dispatch, navigate, user]);

  return (
    <>
      {isLoading ? <Loading /> : null}
      <RegisterUser
        onLoading={(value) => {
          setLoading(value);
        }}
        onSuccess={onSuccessRegister}
        open={registerOpen}
        roleUser={registerUserRole}
        handleClose={() => dispatch(HomeActions.closeRegisterModal())}
      />
      <Login
        onLoading={(value) => {
          setLoading(value);
        }}
        onSuccess={onSuccess}
        open={loginOpen}
        handleClose={() => dispatch(HomeActions.closeLoginModal())}
      />
      <NavBarHomePage onSelectMenu={onSelectMenu} />
      {goAbout ? (
        <AboutSection />
      ) : (
        <div>
          {/* <SectionOne setGoAbout={setGoAbout} /> */}
          <Grid container>
            <Grid item xs={12} sx={{ mt: 12 }}>
              <TitleHowItsWork>HOW IT WORKS?</TitleHowItsWork>
            </Grid>
            <Grid item xs={2} />
            <Grid item xs={8}>
              <ContainerImg src={HowItWorks} />
            </Grid>
          </Grid>
          <SectionRegister onClickVenue={openJoinVenue} onClickVendor={openJoinVendor} />
        </div>
      )}
      <FooterHomePage />
    </>
  );
}
